import { render } from "./SocialAccountDataDeletionRequested.vue?vue&type=template&id=ae991cf4&ts=true"
import script from "./SocialAccountDataDeletionRequested.vue?vue&type=script&lang=ts"
export * from "./SocialAccountDataDeletionRequested.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QItemSection,QItemLabel});
